import axios from "axios";
//Home Services
export const Settings = async (lang) => {
    const url = `https://api.alwatanfac.com.sa/api/home/settings`;
    let data = await axios.get(url, {
        headers: {
            'Content-Type': 'multipart/form-data',
            'X-Requested-With': 'application/json',
            'Accept-Language': lang,
        }
    }).catch((err) => {
    })
    return data
};
export default Settings
